<template>
  <div class="import-lisencepicture-log">
    <el-tabs v-model="activeTabName" type="card">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.name"
        :name="item.key"
      ></el-tab-pane>
    </el-tabs>

    <QS-common-table
      :data="taskTableData"
      :columns="taskTableColumns"
      row-key="id"
      :pagination="pagination"
      :loading="loading"
      @change="handlePaginationChange"
    >
    </QS-common-table>

    <el-dialog
      title="错误详情"
      :visible.sync="dialog.visible"
      @closed="handleDialogClose"
    >
      <div class="table-wrapper">
        <el-table :data="dialog.errorTableData" v-loading="dialog.loading">
          <el-table-column
            v-for="item in errorTableColums"
            :property="item.columnProps.prop"
            :label="item.columnProps.label"
            :key="item.name"
          ></el-table-column>
        </el-table>
        <el-pagination
          class="table-pagination"
          :page-sizes="dialog.pageSizes"
          :page-size="dialog.pageSize"
          :current-page="dialog.pageNum"
          :total="dialog.total"
          :layout="dialog.layout"
          background
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="OCR错误日志"
      :visible.sync="ocrDialog.visible"
      @closed="handleOcrDialogClose"
    >
      <div class="table-wrapper">
        <el-table :data="ocrDialog.errorTableData">
          <el-table-column prop="fileName" label="文件名">
            <template slot-scope="scope">
              <span>{{ scope.row.fileName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="filePath" label="图片预览">
            <template slot-scope="scope">
              <img
                class="ocr-picture"
                :src="scope.row.filePath"
                @click="
                  () => {
                    scope.row.filePath && openImgView(scope.row.filePath)
                  }
                "
              />
            </template>
          </el-table-column>
          <el-table-column prop="failReason" label="错误原因">
            <template slot-scope="scope">
              <span>{{ scope.row.failReason }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="table-pagination"
          :page-sizes="ocrDialog.pageSizes"
          :page-size="ocrDialog.pageSize"
          :current-page="ocrDialog.pageNum"
          :total="ocrDialog.total"
          :layout="ocrDialog.layout"
          background
          @size-change="handleOcrPageSizeChange"
          @current-change="handleOcrCurrentPageChange"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <ImageView
      v-if="imgViewShow"
      :imgViewShow="imgViewShow"
      :imgList="imgViewList"
      @closeImgView="closeImgView"
    />
  </div>
</template>
<script>
import moment from 'moment'
import ImageView from '@/components/UploadCommon/components/ImageView'
import { uploadTaskGetPage, uploadTaskGetDetail } from '@/api/currencyApi'
import {
  downloadTaskErrorDetail,
  getOcrErrorDetail,
} from '@/api/domain/vehicle'
import { downloadFileByUrl } from '@/utils/download'
import mixin from '../mixins'

export default {
  mixins: [mixin],
  data() {
    return {
      uploadType: 2, // 任务类型，2:证照图片导入
      activeTabName: 'lisencepicture',
      tabList: [
        {
          name: '证照图片导入历史',
          key: 'lisencepicture',
          number: 0,
          value: 1,
        },
      ],
      taskTableData: [],
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      loading: false,
      dialog: {
        visible: false,
        errorTableData: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 30, 50, 100],
        layout: 'total,sizes,prev,pager,next,jumper',
        taskId: null,
        loading: false,
      },
      ocrDialog: {
        visible: false,
        errorTableData: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        pageSizes: [10, 20, 30, 50, 100],
        layout: 'total,sizes,prev,pager,next,jumper',
        taskId: null,
      },
      imgViewShow: false,
      imgViewList: [],
    }
  },
  methods: {
    handlePaginationChange(payload) {
      const { pagination } = payload
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.pageNum
      this.getUploadTaskData()
    },
    async getUploadTaskData() {
      this.loading = true
      const params = {
        uploadType: this.uploadType,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum,
      }
      uploadTaskGetPage(params)
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.taskTableData = data?.items || []
            this.pagination.total = data?.totalNum || 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getUploadTaskErrorDetail() {
      this.dialog.visible = true
      this.dialog.loading = true
      const params = {
        pageNum: this.dialog.pageNum,
        pageSize: this.dialog.pageSize,
        id: this.dialog.taskId,
      }
      uploadTaskGetDetail(params)
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.dialog.errorTableData = data.items
            this.dialog.pageNum = data.pageNum
            this.dialog.pageSize = data.pageSize
            this.dialog.total = data.totalNum
          }
        })
        .finally(() => {
          this.dialog.loading = false
        })
    },
    async getOcrErrorDetail() {
      this.ocrDialog.visible = true
      const params = {
        pageNum: this.ocrDialog.pageNum,
        pageSize: this.ocrDialog.pageSize,
        id: this.ocrDialog.taskId,
      }
      getOcrErrorDetail(params).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.ocrDialog.errorTableData = data.items
          this.ocrDialog.pageNum = data.pageNum
          this.ocrDialog.pageSize = data.pageSize
          this.ocrDialog.total = data.totalNum
        }
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    viewErrorDetail(id) {
      this.dialog.taskId = id
      this.getUploadTaskErrorDetail()
    },
    // eslint-disable-next-line vue/no-unused-properties
    viewOcrErrorDetail(id) {
      this.ocrDialog.taskId = id
      this.getOcrErrorDetail()
    },
    // eslint-disable-next-line vue/no-unused-properties
    downloadErrorDetail(id) {
      downloadTaskErrorDetail({ id }).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          const dateTime = moment().format('YYMMDDHHmmss')
          const fileName = `证照录入失败-${dateTime}.xlsx`
          this.downloadFileByUrl(data, fileName)
        } else {
          this.$message.error('老数据暂不支持下载错误明细')
        }
      })
    },
    downloadFileByUrl(url, fileName) {
      downloadFileByUrl(url, fileName)
    },
    handleDialogClose() {
      this.dialog.errorTableData = []
      this.dialog.total = 0
      this.dialog.pageSize = 10
      this.dialog.pageNum = 1
      this.dialog.taskId = null
    },
    handleOcrDialogClose() {
      this.ocrDialog.errorTableData = []
      this.ocrDialog.total = 0
      this.ocrDialog.taskId = null
    },
    handlePageSizeChange(val) {
      this.dialog.pageSize = val
      this.dialog.pageNum = 1
      this.getUploadTaskErrorDetail()
    },
    handleCurrentPageChange(val) {
      this.dialog.pageNum = val
      this.getUploadTaskErrorDetail()
    },
    handleOcrPageSizeChange(val) {
      this.ocrDialog.pageSize = val
      this.ocrDialog.pageNum = 1
      this.getOcrErrorDetail()
    },
    handleOcrCurrentPageChange(val) {
      this.ocrDialog.pageNum = val
      this.getOcrErrorDetail()
    },
    openImgView(img) {
      this.imgViewList = [img]
      this.imgViewShow = true
    },
    closeImgView() {
      this.imgViewShow = false
      this.imgViewList = []
    },
  },
  created() {
    this.getUploadTaskData()
  },
  components: {
    ImageView,
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.table-pagination {
  margin-top: 12px;
}
.error-detail-btn,
.error-download-btn,
.ocr-detail-btn {
  margin: 0 12px 0 0 !important;
}
.ocr-picture {
  display: inline-block;
  width: 54px;
  height: 54px;
  cursor: pointer;
}
</style>
